<template>
  <div class="route-page">
    <div class="route-header">Claim</div>
    <div class="route-body">Claim Rewards<br/>Coming Soon</div>
  </div>
</template>

<script>
export default { name: 'ClaimPage' }
</script>

<style scoped>
.route-page { min-height: 100vh; background: #000; color: #fff; padding-bottom: 120px; }
.route-header { padding: 24px; font-size: 28px; font-weight: 700; }
.route-body { padding: 24px; opacity: .7; }
</style>
